// components/cnt-info/component
/* global DEBUG */

import template  from './component.jade'
import types     from './scss/types.scss'
import operat    from './scss/operations.scss'

import Store     from 'Store'
import parseTime from 'lib/filters/parseUnixTime'

var name = 'cnt-info'
var url = '/api/CntInfo'

const store = new Store(name)

// таблица сопоставляет операции с именем иконки операции
var operations = {
    'Взвешивание': {'': 'Vzveshivanie'},
    'Взвешивание VGM': {'': 'Vzveshivanie_VGM_3'},
    'Выставление': {'': 'Vistavlenie'},
    'Дезинфекция': {'': 'Dezinfekciia'},
    'Досмотр': {
        '': 'Dosmotr_3',
        '10 %': 'Dosmotr_10',
        '50 %': 'Dosmotr_50',
        '100 %': 'Dosmotr_100',
        'Пломбирование': 'Plomba',
    },
    'Затарка': {'': 'Zatarka'},
    'Крепление обрусовка': {'': 'Obrusovka'},
    'МИДК': {'': 'MIDK'},
    'Отключение': {'': 'Otkluchenie'},
    'Передача контейнеров': {'': 'Peredacha'},
    'Подключение': {'': 'Podkluchenie'},
    'Приход': {'': 'Prihod'},
    'Промывка': {'': 'Promivka'},
    'Растарка': {'': 'Rastarka'},
    'Расход': {'': 'Rashod'},
    'Снабжение': {'': 'Snabzhenie'},
}

export default {

    name: name,
    template: template(),
    props: ['table', 'title'],
    mixins: [parseTime],

    data: () => ({
        url: url,
        name: name,
        operations: operations,
    }),

    events: {
        ['number:' + name]: function (data) {
            var {number: number} = data
            //DEBUG && console.log('number:' + name, number)
            this.$set('current', number)
            this.$set('title', number)

            this.$set('data', null)
            this.$set('data', data)
            this.$set('data', store.$get(this))
        },
    },
    watch: {
        data: function () {
            var min, max

            if (!this.$get('data').table) return;
            for (var row of this.$get('data').table) {
                min = (min < row.date) ? min : row.date
                max = (max > row.date) ? max : row.date
            }
            if (min === undefined){
                min = (Date.now()/1000);
            }
            if (max === undefined){
                max = (Date.now()/1000);
            }
           // console.log('dates:bill-list -', min, max, this.current)
            this.$parent.$broadcast('dates:bill-list', {
                name: 'bill-list',
                number: this.current,
                date_at: min,
                date_to: max,
            })
        }
    },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/cnt-info/component.js
 **/